if (process.env.NODE_ENV === 'production') {
    console.log = () => {};
    console.info = () => {};
    console.debug = () => {};
    console.warn = () => {};
    // console.error = () => {};
}

export {}; // Ensures this file is treated as a module
